import { OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { Globals } from '../objects/Globals';
import { ActivatedRoute, Router } from '@angular/router';
import { SummaryService } from '../services/summary.service';
import { SummarySortOption, SummaryPage } from '../objects/SummaryObject';
import { WorkspaceService } from '../services/workspace.service';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
import { ConfirmationService } from '../services/confirmation.service';
import { ToasterMessageService } from '../services/toaster-message.service';
var SummaryComponent = /** @class */ (function () {
    function SummaryComponent(route, globals, summaryService, router, workspaceService, contextMenuService, confirmationService, toasterMessageService) {
        var _this = this;
        this.route = route;
        this.globals = globals;
        this.summaryService = summaryService;
        this.router = router;
        this.workspaceService = workspaceService;
        this.contextMenuService = contextMenuService;
        this.confirmationService = confirmationService;
        this.toasterMessageService = toasterMessageService;
        this.sortDirectionIsAscending = true;
        this.smallSum = false;
        this.changeSummaryLayout = '';
        this.isCardView = true;
        this.fetching = false;
        this.enableSearch = false;
        this.keyword = '';
        this.showPagination = true;
        this.hidePanel = false;
        this.selectedId = new EventEmitter();
        this.selectedCardId = new EventEmitter();
        this.selectedType = new EventEmitter();
        this.updateParent = new EventEmitter();
        this.updateTotalRows = new EventEmitter();
        this.toggleSummary = new EventEmitter();
        this.setSummaryName = new EventEmitter();
        this.keywordChanged = new EventEmitter();
        this.subscription = this.workspaceService.currentParentIdChanged$.subscribe(function (id) {
            if (_this.componentId == id) {
                _this.forceRefresh = !_this.forceRefresh;
            }
        });
        this.subscription1 = this.summaryService.enableSearchChanged$.subscribe(function (result) {
            if (!result)
                result = false;
            _this.enableSearch = result;
        });
    }
    Object.defineProperty(SummaryComponent.prototype, "setSelectedDetailId", {
        set: function (id) { this.selectedItemId = id; },
        enumerable: true,
        configurable: true
    });
    SummaryComponent.prototype.onResize = function (event) {
        if (event.target.innerWidth < 992) {
            if (this.smallSum) {
                this.onMobile = true;
            }
        }
        else {
            this.onMobile = false;
        }
    };
    SummaryComponent.prototype.selectedSortOptionSortField = function () {
        if (this.selectedSortOption) {
            return this.selectedSortOption.SortField;
        }
        else {
            return null;
        }
    };
    SummaryComponent.prototype.onSelectedItem = function (selectedId) {
        this.selectedId.emit(selectedId);
        this.onMobile = window.innerWidth < 992;
        this.smallSum = true;
    };
    SummaryComponent.prototype.onSelectedType = function (selectedType) {
        this.selectedType.emit(selectedType);
    };
    SummaryComponent.prototype.onSelectedCardId = function (selectedId) {
        this.selectedCardId.emit(selectedId);
        this.onMobile = true;
    };
    SummaryComponent.prototype.changeLayout = function (isCardView, type) {
        if (isCardView != this.isCardView) {
            this.changeSummaryLayout = type;
        }
    };
    SummaryComponent.prototype.onSearchOptionsChange = function (sortOptions) {
        var _this = this;
        this.sortOptions = sortOptions;
        this.summaryService.getCurrentSort(this.componentId).subscribe(function (result) {
            var sortedField = result.split('|')[0];
            var sortedIsAsc = result.split('|')[1];
            if (_this.sortOptions.find(function (x) { return x.SortField == sortedField; })) {
                _this.selectedSortValue = _this.sortOptions.find(function (x) { return x.SortField == sortedField; }).SortOptionDisplay;
                _this.sortOptionType = _this.sortOptions.find(function (x) { return x.SortField == sortedField; }).SortOptionType;
            }
            _this.sortDirectionIsAscending = (sortedIsAsc.toLowerCase() == "true");
            _this.formatSortOrder();
        });
    };
    SummaryComponent.prototype.onFilterChanged = function (selectedOption) {
        this.selectedSortOption = this.sortOptions.find(function (x) { return x.SortField == selectedOption; });
        this.sortOptionType = this.selectedSortOption.SortOptionType;
    };
    SummaryComponent.prototype.onChangeSortDirection = function () {
        if (this.sortOrder == "A-Z") {
            this.sortOrder = "Z-A";
        }
        else if (this.sortOrder == "Z-A") {
            this.sortOrder = "A-Z";
        }
        else if (this.sortOrder == "Newest") {
            this.sortOrder = "Oldest";
        }
        else if (this.sortOrder == "Oldest") {
            this.sortOrder = "Newest";
        }
        this.sortDirectionIsAscending = !this.sortDirectionIsAscending;
    };
    SummaryComponent.prototype.onCurrentPageChange = function (currentPage) {
        this.currentPageChange = currentPage;
    };
    SummaryComponent.prototype.onSummaryPageChange = function ($event) {
        this.currentPage = $event.currentPage;
        this.availablePages = $event.availablePage;
        this.pagination(this.currentPage, this.availablePages);
    };
    SummaryComponent.prototype.onSummaryTotalRowsChange = function (totalRows) {
        this.totalRows = totalRows;
        this.updateTotalRows.emit(this.totalRows);
    };
    SummaryComponent.prototype.changePagingSize = function (pageSize) {
        this.pageSize = pageSize;
    };
    SummaryComponent.prototype.previousPage = function () {
        this.prevPageDummy = !this.prevPageDummy;
    };
    SummaryComponent.prototype.nextPage = function () {
        this.nextPageDummy = !this.nextPageDummy;
    };
    SummaryComponent.prototype.switchSummary = function () {
        this.onMobile = false;
        //this.toggleSummary.emit(true);
    };
    SummaryComponent.prototype.forceSummaryRefresh = function (event) {
        this.forceRefresh = !this.forceRefresh;
    };
    SummaryComponent.prototype.updateParentControl = function (event) {
        this.updateParent.emit(event);
    };
    SummaryComponent.prototype.setSummary = function ($event) {
        this.summaryName = $event;
        this.setSummaryName.emit($event);
    };
    SummaryComponent.prototype.formatSortOrder = function () {
        switch (this.sortOptionType) {
            case "TEXT":
            default:
                if (this.sortDirectionIsAscending) {
                    this.sortOrder = "A-Z";
                }
                else {
                    this.sortOrder = "Z-A";
                }
                break;
            case "DATE":
                if (this.sortDirectionIsAscending) {
                    this.sortOrder = "Oldest";
                }
                else {
                    this.sortOrder = "Newest";
                }
                break;
            case "NUMBER":
                this.sortOrder = "";
                break;
        }
    };
    SummaryComponent.prototype.pagination = function (currentPage, pagesNo) {
        var delta = 2, range = [], l;
        this.rangeWithDots = [];
        range.push(1);
        if (pagesNo <= 1) {
            return range;
        }
        for (var i = currentPage - delta; i <= currentPage + delta; i++) {
            if (i < pagesNo && i > 1) {
                range.push(i);
            }
        }
        range.push(pagesNo);
        for (var _i = 0, range_1 = range; _i < range_1.length; _i++) {
            var i = range_1[_i];
            if (l) {
                if (i - l === 2) {
                    this.rangeWithDots.push(l + 1);
                }
                else if (i - l !== 1) {
                    this.rangeWithDots.push('...');
                }
            }
            this.rangeWithDots.push(i);
            l = i;
        }
        //return rangeWithDots;
    };
    SummaryComponent.prototype.onContextMenu = function ($event, item) {
        if ($event.button == 0) {
            this.contextMenuService.show.next({
                anchorElement: $event.target,
                contextMenu: this.basicMenu,
                event: $event,
                item: item,
            });
        }
        $event.preventDefault();
        $event.stopPropagation();
    };
    SummaryComponent.prototype.saveSetting = function () {
        var _this = this;
        var sortBy = "ascending";
        if (!this.sortDirectionIsAscending)
            sortBy = "descending";
        this.confirmationService.confirm("Save current sorting as my default?", "<p>Do you want to save the sorting of \"" + this.selectedSortValue + "\" in " + sortBy + " order as my default for this list?</p>", ["NO", "YES"], false)
            .subscribe(function (respond) {
            if (respond.answer == "YES") {
                _this.summaryService.saveCurrentSummarySortLayout(_this.componentId).subscribe(function (result) {
                    if (result == "1") {
                        _this.toasterMessageService.popToast("Info", "Your default sorting has been updated", "info");
                    }
                });
            }
        });
    };
    SummaryComponent.prototype.ngOnDestroy = function () {
        if (this.subscription)
            this.subscription.unsubscribe();
        if (this.subscription1)
            this.subscription1.unsubscribe();
    };
    SummaryComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.componentId && this.globals.Session) {
            this.summaryService.getCurrentSearchKeyword(this.componentId).subscribe(function (result) {
                if (result) {
                    _this.keyword = result;
                }
            });
        }
    };
    return SummaryComponent;
}());
export { SummaryComponent };
